import { RetryContext } from '@microsoft/signalr';
import { ISignalRRetryPolicy } from './signalr.retry.policy.interface';

export class SignaRRetryPolicy implements ISignalRRetryPolicy {

    public nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
        return this.doNextRetryDelayInMilliseconds(retryContext);
    }

    protected doNextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
        return ((retryContext.previousRetryCount <= 3) ? (1000 * 10) : (1000 * 60));
    }

}
